import { useState, type FormEvent } from 'react';
import { useApp } from '@/state/AppContext';
import { Knop } from '@/components/ui/Knop';
import { Tekstveld } from '@/components/ui/Velden';
import { Bureaulogo, Merkteken } from '@/components/layout/Merk';
import './inlog.css';

/**
 * Inlogscherm. Accounts worden niet hier aangemaakt: de beheerder zet ze klaar
 * in Supabase, zodat niemand zichzelf toegang kan geven tot bewonersgegevens.
 */
export function InlogScherm(): JSX.Element {
  const { inloggen } = useApp();
  const [email, setEmail] = useState('');
  const [wachtwoord, setWachtwoord] = useState('');
  const [fout, setFout] = useState<string | null>(null);
  const [bezig, setBezig] = useState(false);

  const verstuur = async (event: FormEvent) => {
    event.preventDefault();
    setFout(null);
    setBezig(true);

    try {
      await inloggen(email, wachtwoord);
    } catch (error) {
      setFout(error instanceof Error ? error.message : 'Inloggen is niet gelukt.');
    } finally {
      setBezig(false);
    }
  };

  return (
    <div className="inlog">
      <div className="inlog__merk">
        <Merkteken formaat={72} diapositief />
        <h1>Afkoppelcoach</h1>
        <span className="inlog__ondertitel">Gebiedsmanagers</span>
      </div>

      <form className="inlog__kaart" onSubmit={(event) => void verstuur(event)}>
        <p className="inlog__uitleg">
          Log in met het account dat je van de beheerder hebt gekregen.
        </p>

        <Tekstveld
          label="E-mailadres"
          type="email"
          inputMode="email"
          waarde={email}
          bijWijziging={setEmail}
          autoComplete="username"
          placeholder="jouw@gebiedsmanagers.nl"
        />

        <div className="veld">
          <label className="veld__label" htmlFor="wachtwoord">
            Wachtwoord
          </label>
          <input
            id="wachtwoord"
            className="invoer"
            type="password"
            value={wachtwoord}
            autoComplete="current-password"
            onChange={(event) => setWachtwoord(event.target.value)}
          />
        </div>

        {fout && (
          <p className="veld__fout" role="alert">
            {fout}
          </p>
        )}

        <Knop
          type="submit"
          variant="primair"
          breed
          bezig={bezig}
          disabled={!email || !wachtwoord}
        >
          Inloggen
        </Knop>

        {/* Inloggen vraagt bereik, daarna niet meer. Zonder deze regel denkt
            een coach bij elke foutmelding dat het aan zijn verbinding ligt —
            of erger, dat hij zonder bereik niet kan werken. */}
        <p className="inlog__bereik">
          Inloggen heeft eenmalig bereik nodig. Daarna werkt de app gewoon door zonder
          verbinding.
        </p>

        {/* Van wie deze app is. Onderaan het inlogscherm, waar iemand het
            één keer bewust ziet in plaats van dat het overal meereist. */}
        <div className="inlog__bureau">
          <span>Een app van</span>
          <Bureaulogo hoogte={26} />
        </div>
      </form>
    </div>
  );
}
